import { useState } from 'react';

import Honeybadger from '@honeybadger-io/js';

import { createMessage as apiCreateMessage } from '../services/messageService';

const useForm = ({ fetchMessages, taskId }) => {
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [messageContent, setMessageContent] = useState('');

  const handleChange = (event) => {
    setMessageContent(event.target.value);
  };

  const handleSuccess = () => {
    setMessageContent('');
    fetchMessages();
  };

  const createMessage = async () => {
    try {
      await apiCreateMessage({ messageContent, taskId });
      await handleSuccess();
    } catch (error) {
      setErrorMessage(error.message);
      Honeybadger.notify(error);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setErrorMessage('');
    setIsLoading(true);

    await createMessage();

    setIsLoading(false);
  };

  return {
    errorMessage,
    handleChange,
    handleSubmit,
    isLoading,
    messageContent,
  };
};

export default useForm;
